var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackTuskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316,
    height: 39.001,
    viewBox: "0 0 316 39.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 39,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.092 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.566,21.738q0-8.4-6.556-8.4a5.971,5.971,0,0,0-5.155,2.381,10.57,10.57,0,0,0-1.737,6.359v4.989A9.806,9.806,0,0,0,32.94,33.2a6.253,6.253,0,0,0,5.293,2.381q6.332,0,6.333-8.46ZM31.118,38.66H27.307V0h3.811V14.23a8.435,8.435,0,0,1,3.052-3.249A8.322,8.322,0,0,1,38.514,9.86a9.476,9.476,0,0,1,7.115,2.83q2.746,2.83,2.745,8.826v5.826q0,5.993-2.689,8.826A9.087,9.087,0,0,1,38.793,39q-5.321,0-7.675-4.089Z",
    transform: "translate(52.59)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.043,31.208V0h3.811V30.986a4.94,4.94,0,0,0,.841,3.193,3.384,3.384,0,0,0,2.745,1.008h2.3V38.66H44.047a6.819,6.819,0,0,1-5.211-1.9,7.807,7.807,0,0,1-1.793-5.548",
    transform: "translate(71.373)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.911,22.529v-3.7H51.8q-6.274,0-6.274,5.267,0,5.321,6.219,5.322,3.752,0,5.463-1.711a7.042,7.042,0,0,0,1.708-5.182m3.811-9.693v19.33H58.966V29.14a7.7,7.7,0,0,1-3.193,2.551,11.892,11.892,0,0,1-4.649.811q-4.486,0-6.948-2.13a7.761,7.761,0,0,1-2.466-6.219A7.477,7.477,0,0,1,44.2,18.188q2.5-2.157,7.033-2.159h7.675V12.781a6.058,6.058,0,0,0-1.681-4.652,6.711,6.711,0,0,0-4.76-1.567A7.151,7.151,0,0,0,47.9,7.877a4.366,4.366,0,0,0-1.655,3.615v.167h-3.7V11.38a7.194,7.194,0,0,1,2.633-5.829,10.988,10.988,0,0,1,7.226-2.185q4.987,0,7.648,2.411t2.663,7.059",
    transform: "translate(80.377 6.494)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.427,20.849V15.02q0-6.046,3-8.849a11.306,11.306,0,0,1,8.041-2.8,11,11,0,0,1,7.7,2.578A8.871,8.871,0,0,1,73,12.837v.278H69.3v-.278a5.576,5.576,0,0,0-1.793-4.429,7.146,7.146,0,0,0-4.874-1.567A7.534,7.534,0,0,0,57.2,8.719q-1.96,1.876-1.96,6.526v5.378q0,4.706,1.933,6.585a7.437,7.437,0,0,0,5.4,1.878,7.236,7.236,0,0,0,4.933-1.57A5.57,5.57,0,0,0,69.3,23.09v-.281H73v.226a8.831,8.831,0,0,1-2.856,6.893A10.962,10.962,0,0,1,62.52,32.5a11.462,11.462,0,0,1-8.1-2.774q-3-2.777-3-8.881",
    transform: "translate(99.123 6.496)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.335,0V38.663h3.808V30.2l5.325-6.274L79.1,38.663h4.652L72.988,21.012l9.133-10.759H77.528L65.143,25.382V0Z",
    transform: "translate(118.238 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,30.141q0,3.867,3.641,3.867h2.241v3.363H85.43a6.735,6.735,0,0,1-5.071-1.878,7.129,7.129,0,0,1-1.822-5.185V11.986H74.111V8.963h4.426v-6.5L82.4.67V8.963h6.386v3.023H82.4Z",
    transform: "translate(142.887 1.293)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.38,21.486V3.5h3.811V20.982q0,3.919,1.511,5.882t5.1,1.963q3.585,0,5.1-1.907t1.511-5.938V3.5h3.808V21.486q0,5.211-2.6,7.985t-7.871,2.774q-5.158,0-7.763-2.774t-2.6-7.985",
    transform: "translate(156.91 6.752)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.81,24.211v-.226h3.7v.17a4.42,4.42,0,0,0,1.822,3.726,7.96,7.96,0,0,0,4.9,1.371,8.542,8.542,0,0,0,5.015-1.289,4.254,4.254,0,0,0,1.819-3.7,3.771,3.771,0,0,0-1.26-3.137,9.257,9.257,0,0,0-4.063-1.514L99.214,19a12.027,12.027,0,0,1-6.052-2.466,6.482,6.482,0,0,1-1.9-5.041A7.2,7.2,0,0,1,94,5.581a10.983,10.983,0,0,1,7.115-2.215,12,12,0,0,1,7.511,2.159,6.778,6.778,0,0,1,2.8,5.63v.337h-3.7v-.167a4.148,4.148,0,0,0-1.737-3.53,7.816,7.816,0,0,0-4.76-1.289A7.34,7.34,0,0,0,96.61,7.8a4.22,4.22,0,0,0-1.652,3.53,3.634,3.634,0,0,0,1.175,2.882A7.669,7.669,0,0,0,99.888,15.7l3.7.671a12.858,12.858,0,0,1,6.192,2.548,6.5,6.5,0,0,1,1.989,5.129,7.383,7.383,0,0,1-2.915,6.245,12.552,12.552,0,0,1-7.789,2.215,11.588,11.588,0,0,1-7.452-2.241,7.348,7.348,0,0,1-2.8-6.052",
    transform: "translate(175.103 6.494)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.163,0V38.663h3.811V30.2l5.322-6.274,8.627,14.737h4.652L111.815,21.012l9.136-10.759h-4.6l-12.382,15.13V0Z",
    transform: "translate(193.147 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.814,23.872l.712-6.965L53.761,32.078Zm-5.941-4.787L41.4,16.5l-.744,7.289-6.513,2.706,1.725-7.408Zm-9.79-1.024L25.468,7.85,34.719,18.8,33,26.169ZM24.271,7.688l.6,10.006L5,30.353,24.271,7.688ZM0,39H58.387V0H0Z",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTuskLogo);
export default __webpack_public_path__ + "static/media/black_tusk_logo.1f9347f175d3a1bad4b3e7595665fcc8.svg";
export { ForwardRef as ReactComponent };